import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { GuideCost } from '../types/entities/GuideCost';
import { DateField } from '../components/Table/fields/DateField';
import { statuses } from './statuses';
import { SelectFieldWithoutAutocomplete } from '../components/Table/fields/SelectFieldWithoutAutocomplete';

export const guideCost: SchemaWithClient<GuideCost> = {
  name: 'Guide Costs',
  pluralName: 'Guide Costs',
  columns: {
    name: {
      name: 'Title',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
      listItem: {
        width: '25%',
        align: 'left',
      },
    },
    guide: {
      name: 'Guide',
      required: true,
      fieldRenderer: SelectField.tableAdapter(enumItems.guide),
      url: enumItems.guide.client.getAllPath,
      tempSchema: enumItems.guide,
      switchboard: true,
      listItem: {
        width: '25%',
        align: 'left',
      },
    },
    total_cost: {
      name: 'Total Cost',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      listItem: {
        width: '15%',
        align: 'left',
      },
    },
    guide_cost_status: {
      name: 'Cost Status',
      fieldRenderer: SelectFieldWithoutAutocomplete.tableAdapter(
        statuses.guideCostStatus
      ),
      url: statuses.guideCostStatus.client.getAllPath,
      tempSchema: statuses.guideCostStatus,
      switchboard: true,
    },
    currency: {
      name: 'Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      switchboard: true,
      listItem: {
        width: '15%',
        align: 'left',
      },
    },
    user: {
      name: 'Paid User',
      fieldRenderer: SelectField.tableAdapter(enumItems.user),
      url: enumItems.user.client.getAllPath,
      tempSchema: enumItems.user,
      switchboard: true,
    },
    payment_method: {
      name: 'Payment Method',
      fieldRenderer: SelectField.tableAdapter(enumItems.paymentMethod),
      url: enumItems.paymentMethod.client.getAllPath,
      tempSchema: enumItems.paymentMethod,
      switchboard: true,
      listItem: {
        width: '20%',
        align: 'left',
      },
    },
    payment_date: {
      name: 'Payment Date',
      fieldRenderer: DateField,
      fieldType: 'date',
    },
    notes: {
      name: 'Notes',
      fieldRenderer: TextField,
      fieldType: 'textarea',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/guide-costs'),
};
